export const getValidateCheckinDateErrorMsg = ({
  code, i18n,
}) => {
  if (code.value === '' || code.value == null) {
    return i18n.getString(_TL_('Required field'));
  }
  return null;
};

export const validateCheckinDate = ({ value }) => {
  if (value === '' || value == null) {
    return 'RequiredField';
  }
  return null;
};

function getDaysBetween(dateString1, dateString2) {
  const startDate = Date.parse(dateString1);
  const endDate = Date.parse(dateString2);
  const days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
  return days;
}

export const isCheckinDateOverlapCal = (dt1, dt2) => {
  const start1 = dt1.startDate;
  const end1 = dt1.endDate;
  const start2 = dt2.startDate;
  const end2 = dt2.endDate;
  let [isStart1EarlyThanEnd1, isStart2EarlyThanEnd2, isEnd1EarlyThanStart2, isRange1NotGreaterThan999, isRange2NotGreaterThan999] = [true, true, true, true, true];
  if (dt1.startDate && dt1.endDate) {
    isStart1EarlyThanEnd1 = start1 <= end1;
    isRange1NotGreaterThan999 = getDaysBetween(start1, end1) <= 999;
  }
  if (dt2.startDate && dt2.endDate) {
    isStart2EarlyThanEnd2 = start2 <= end2;
    isRange2NotGreaterThan999 = getDaysBetween(start2, end2) <= 999;
  }
  if (dt1.endDate && dt2.startDate) {
    isEnd1EarlyThanStart2 = end1 < start2;
  }
  if (!isStart1EarlyThanEnd1 || !isStart2EarlyThanEnd2) {
    return 'startdate_greater_than_enddate';
  }
  if (!isEnd1EarlyThanStart2) {
    return 'adjust_settings';
  }
  if (!isRange1NotGreaterThan999 || !isRange2NotGreaterThan999) {
    return 'out_of_checkin_date_range';
  }
  return '';
};
